import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { url } from "./api";

// Create a Socket Context
const SocketContext = createContext(null);

// Create a Socket Provider Component
export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  // Function to store token and reconnect socket
  const onStoreToken = async (newToken) => {
    try {
      await localStorage.setItem("token", newToken);
      console.log("🔐 New Token Stored:", newToken);

      // Disconnect previous socket if exists
      if (socket) {
        socket.disconnect();
      }

      // Create a new socket connection with the updated token
      const newSocket = io(url, {
        auth: { token: newToken, role: "consultant" },
        // transports: ['websocket', 'polling'], // Ensure both transports are allowed
        // withCredentials: true,
      });

      setSocket(newSocket);
    } catch (error) {
      console.error("❌ Error storing token:", error);
    }
  };

  useEffect(() => {
    let isMounted = true; // Track component mount state

    const initializeSocket = async () => {
      const token = await localStorage.getItem("token");
      console.log("📡 Socket Provider Token:", token);

      if (token) {
        // Initialize the socket connection
        const socketConnection = io(url, {
          auth: {
            token,
            role: "consultant",
          },
          // transports: ['websocket', 'polling'], // Ensure both transports are allowed
          // withCredentials: true,
        });

        // Only update state if component is still mounted
        if (isMounted) {
          setSocket(socketConnection);
        }

        // Cleanup function
        return () => {
          isMounted = false;
          socketConnection.disconnect();
        };
      }
    };

    initializeSocket();

    return () => {
      isMounted = false;
      if (socket) {
        socket.disconnect();
      }
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, onStoreToken }}>
      {socket ? <>{children}</> : <FullScreenLoader />}
    </SocketContext.Provider>
  );
};

// Custom Hook to Use Socket Context
export const useSocket = () => {
  return useContext(SocketContext);
};

export default function FullScreenLoader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-pink-100 via-pink-200 to-pink-300 z-50">
      <div className="flex flex-col items-center space-y-4">
        {/* Loader */}
        <div className="w-14 h-14 border-4 border-gray-300 border-t-[#A40165] rounded-full animate-spin" />

        {/* Text */}
        <h1 className="text-xl font-semibold text-gray-700 tracking-wide">
          Loading...
        </h1>
      </div>
    </div>
  );
}
